import { configureStore, createAction, Tuple, UnknownAction } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import storage from 'redux-persist/es/storage';

import { loadTestApi } from './api/load-test';
import { settingsApi } from './api/settings';

import { rootReducer } from './slices';
import { useDispatch } from 'react-redux';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['authFeature'],
};

export const resetState = createAction('store/reset');

const resettableReducer = (state: ReturnType<typeof rootReducer> | undefined, action: UnknownAction) =>
  rootReducer(resetState.match(action) ? undefined : state, action);

const reducer = persistReducer(persistConfig, resettableReducer);

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddelWare) =>
    getDefaultMiddelWare({
      serializableCheck: { ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] },
    }).concat(loadTestApi.middleware, settingsApi.middleware),
  devTools: { shouldHotReload: true },
});
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>(); // Export a hook that can be reused to resolve types
